import React from "react";
import Slider from "react-slick";
import "./APIExample.css";

function ApiExample() {
  const sliderSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 500,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <div className="api-example container py-5 anchor-adjust" id="api">
      <h2 className="text-center mb-5">How <span className="brand-lowercase">upself</span> works</h2>

      <div className="row how-steps justify-content-center text-center">
        <div className="col-md-3 step-item">
          <div className="step-circle">1</div>
          <p>Choose a topic<br />for reflection</p>
        </div>
        <div className="col-md-3 step-item">
          <div className="step-circle">2</div>
          <p><span className="brand-lowercase">upself</span>’s API<br />delivers the best questions</p>
        </div>
        <div className="col-md-3 step-item">
          <div className="step-circle">3</div>
          <p>Gain insights<br />through personalized panels</p>
        </div>
      </div>

      {/* Carousel */}
      <div className="api-carousel-wrapper">
        <Slider {...sliderSettings}>
          {/* Slide 1: Question API */}
          <div>
            <div className="row justify-content-center align-items-start">
              <div className="col-md-5">
                <h5 className="text-dark text-center mb-3">Question API Example</h5>

                <pre className="code-snippet">
                  <code>
                    <span className="code-keyword">GET</span> <span className="value">https://api.upself.io/api/questions/01WLugxvgbP24BYUl8UQ</span>
                  </code>
                </pre>

                <pre className="code-snippet mt-3">
                  <code>
                    {"{"}{"\n"}
                    &nbsp;&nbsp;"alpha": {"{"}{"\n"}
                    &nbsp;&nbsp;&nbsp;&nbsp;"clean": <span className="value">0.72</span>,{"\n"}
                    &nbsp;&nbsp;&nbsp;&nbsp;"raw": <span className="value">"0.64,0.80"</span>{"\n"}
                    &nbsp;&nbsp;{"}"},{"\n"}
                    &nbsp;&nbsp;"instrument": <span className="value">"Barchard2001"</span>,{"\n"}
                    &nbsp;&nbsp;"key": <span className="value">1</span>,{"\n"}
                    &nbsp;&nbsp;"label": {"{"} "en": <span className="value">"Empathy"</span> {"}"},{"\n"}
                    &nbsp;&nbsp;"text": {"{"} "en": <span className="value">"Am concerned about others."</span> {"}"}{"\n"}
                    {"}"}
                  </code>
                </pre>
              </div>

              <div className="col-md-4 d-flex flex-column align-items-center">
                <div className="insight-card shadow-sm mt-4">
                  <h3>Empathy</h3>
                  <div className="score">0.72</div>
                  <p>Am concerned about others.</p>
                </div>
              </div>
            </div>
          </div>

          {/* Slide 2: Dimension API */}
          <div>
            <div className="row justify-content-center align-items-start">
              <div className="col-md-5">
                <h5 className="text-dark text-center mb-3">Dimension API Example</h5>

                <pre className="code-snippet">
                  <code>
                    <span className="code-keyword">GET</span> <span className="value">https://api.upself.io/api/dimensions/en/Achievement-striving</span>
                  </code>
                </pre>

                <pre className="code-snippet mt-3">
                  <code>
                    {"{"}{"\n"}
                    &nbsp;&nbsp;"metrics": {"{"}{"\n"}
                    &nbsp;&nbsp;&nbsp;&nbsp;"average_alpha": <span className="value">0.78</span>,{"\n"}
                    &nbsp;&nbsp;&nbsp;&nbsp;"degree_centrality": <span className="value">0.1478</span>,{"\n"}
                    &nbsp;&nbsp;&nbsp;&nbsp;"pagerank": <span className="value">0.0083</span>,{"\n"}
                    &nbsp;&nbsp;&nbsp;&nbsp;"total_questions": <span className="value">32</span>{"\n"}
                    &nbsp;&nbsp;{"}"}{"\n"}
                    {"}"}
                  </code>
                </pre>
              </div>

              <div className="col-md-4 d-flex flex-column align-items-center">
                <div className="insight-card shadow-sm mt-4">
                  <h3>Achievement-striving</h3>
                  <div className="score">α = 0.78</div>
                  <p>32 questions • High centrality and relevance</p>
                </div>
              </div>
            </div>
          </div>
        </Slider>
      </div>
    </div>
  );
}

export default ApiExample;
